import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import Navbar2 from "../../components/Navbar2";
import PageTitle from "../../components/pagetitle";
import Scrollbar from "../../components/scrollbar";
import Footer from "../../components/footer";
import { addToCart } from "../../store/actions/action";
import Product from "./product";
import api from "../../api";
import ProductTabs from "./alltab";

const ProductSinglePage = (props) => {
  const productsArray = api();
  const Allproduct = productsArray;

  const { addToCart } = props;
  const [product, setProduct] = useState({});

  useEffect(() => {
    setProduct(
      Allproduct.filter(
        (Allproduct) => Allproduct.id === Number(props.match.params.id)
      )
    );
  }, []);

  const item = product[0];

  const addToCartProduct = (product, qty = 1) => {
    addToCart(product, qty);
  };

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-2"} topbarBlock={"topbar-block"} />
      <PageTitle pageTitle={"Product Single"} pagesub={"Product"} />
      <section className="wpo-shop-single-section section-padding">
        <div className="container">
          {item ? <Product addToCart={addToCartProduct} /> : null}
          {/* <ProductTabs /> */}
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    products: state.data.products,
  };
};

export default connect(mapStateToProps, { addToCart })(ProductSinglePage);
